/* eslint-disable */
import { DeviceState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    deviceList: (state: DeviceState) => state.deviceList,
    deviceSpecs: (state: DeviceState) => state.deviceSpecs,
    deviceSpecsNew: (state: DeviceState) => state.deviceSpecsNew,
    deviceSpecsList: (state: DeviceState) => state.deviceSpecsList,
};

const { read } = getStoreAccessors<DeviceState, State>('');

export const readDeviceSpecs = read(getters.deviceSpecs);
export const readDeviceSpecsNew = read(getters.deviceSpecsNew);
export const readDeviceList = read(getters.deviceList);
export const readDeviceSpecsList = read(getters.deviceSpecsList);

